import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";


@Injectable()
export class LoaderService {

  public loader$: Observable<boolean>;
  public loaderSubject: BehaviorSubject<boolean> = new BehaviorSubject(null);

  constructor(

  ) {
    this.loader$ = this.loaderSubject.asObservable();
  }

  activeLoader() {
    this.loaderSubject.next(true);
  }

  stopLoader() {
    this.loaderSubject.next(false);
  }

}


// WEBPACK FOOTER //
// ./src/app/services/loader/loader.service.ts